import { render, staticRenderFns } from "./upload-video-drawer.vue?vue&type=template&id=37e39eae&scoped=true"
import script from "./upload-video-drawer.vue?vue&type=script&lang=js"
export * from "./upload-video-drawer.vue?vue&type=script&lang=js"
import style0 from "./upload-video-drawer.vue?vue&type=style&index=0&id=37e39eae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e39eae",
  null
  
)

export default component.exports